import { cn } from '@/lib/utils';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';

interface Step {
  label: string;
}

interface StepIndicatorProps {
  steps: Step[];
  currentStep: number;
}

export function StepIndicator({ steps, currentStep }: StepIndicatorProps) {
  return (
    <div className="flex items-center justify-center gap-2 py-6">
      {steps.map((step, index) => {
        const isDone = index < currentStep;
        const isCurrent = index === currentStep;

        return (
          <div key={index} className="flex items-center gap-2">
            {index > 0 && (
              <div
                className={cn(
                  "w-8 h-[1px] transition-colors duration-300",
                  isDone ? "bg-emerald-500" : "bg-border"
                )}
              />
            )}
            <div className="flex items-center gap-2">
              <motion.div
                initial={{ scale: 0.8 }}
                animate={{ scale: 1 }}
                className={cn(
                  "w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-semibold border-[1.5px] transition-all duration-300",
                  isDone && "bg-emerald-500 border-emerald-500 text-white",
                  isCurrent && "bg-primary border-primary text-primary-foreground",
                  !isDone && !isCurrent && "border-border text-muted-foreground bg-background"
                )}
              >
                {isDone ? <Check className="h-3 w-3" /> : index + 1}
              </motion.div>
              <span
                className={cn(
                  "text-xs font-medium transition-colors duration-300 hidden sm:inline",
                  isDone && "text-emerald-600 dark:text-emerald-400",
                  isCurrent && "text-foreground font-semibold",
                  !isDone && !isCurrent && "text-muted-foreground"
                )}
              >
                {step.label}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
